/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAaa_b2b_order_history_detailViewProps } from './aaa_b2b_order_history_detail';
import { IImageSettings, Image } from '@msdyn365-commerce/core';
import moment from 'moment';

export default (props: IAaa_b2b_order_history_detailViewProps) => {
    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
            lg: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
            xl: { q: 'w=100&h=100&m=6', w: 100, h: 100 }
        },
        lazyload: true,
        cropFocalRegion: true
    };
    const numberWithCommas = (x: number) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    return (
        <>
            {!props.isLoading ? (
                <div className={'row aaa-cart-wrapper'}>
                    <div className={'col-auto col-sm-auto col-md-10 col-lg-10 aaa-order-history-detail'}>
                        <>
                            <div className={'aaa-cart-left-section'}>
                                <div className={'col-auto col-sm-auto col-md-3 col-lg-3'}>
                                    <Image
                                        requestContext={props.context.actionContext.requestContext}
                                        altText={props.requestOrderDetail.ProductName}
                                        className='ms-wishlist-items__product-image'
                                        title={props.requestOrderDetail.ProductName}
                                        src={props.requestOrderDetail.ImageURL}
                                        fallBackSrc={''}
                                        gridSettings={props.context.request.gridSettings!}
                                        imageSettings={defaultImageSettings}
                                        loadFailureBehavior={'empty'}
                                    />
                                </div>
                                <div className={'col-auto col-sm-auto col-md-9 col-lg-9 aaa-cart-detail'}>
                                    <div className={'aaa-cart-heading aaa-order-history-heading'}>
                                        <span>{props.requestOrderDetail.ProductName}</span>{' '}
                                    </div>
                                    <div className={'aaa-cart-row'}>
                                        <span className={'aaa-cart-row-column'}>
                                            <span className={'aaa-cart-row-column-heading'}>Customer</span>
                                            <span className={'aaa-cart-row-column-text'}>
                                                {props.requestOrderDetail.B2CCustomerName ? props.requestOrderDetail.B2CCustomerName : '-'}
                                                <br />
                                                {props.requestOrderDetail.B2CPhone ? props.requestOrderDetail.B2CPhone : '-'}
                                                <br />
                                                {props.requestOrderDetail.B2CEmail ? props.requestOrderDetail.B2CEmail : '-'}
                                            </span>
                                        </span>
                                        <span className={'aaa-cart-row-column'}>
                                            <span className={'aaa-cart-row-column-heading'}>Status</span>
                                            <span className={'aaa-cart-row-column-text'}>
                                                {props.requestOrderDetail.LineStatusValue === 1 && 'Open Order'}
                                                {props.requestOrderDetail.LineStatusValue === 2 && 'Delivered'}
                                                {props.requestOrderDetail.LineStatusValue === 3 && 'Invoiced'}
                                                {props.requestOrderDetail.LineStatusValue === 4 && 'Cancelled'}
                                                {props.requestOrderDetail.LineStatusValue === 0 && 'None'}
                                            </span>
                                            <span className={'aaa-cart-row-column-heading'}>Snapshot ID</span>
                                            <span className={'aaa-cart-row-column-text'}>{props.requestOrderDetail.BMASnapShotID}</span>
                                            <span className={'aaa-cart-row-column-heading'}>Order Number</span>
                                            <span className={'aaa-cart-row-column-text'}>
                                                {props.requestOrderDetail.RequestOrderId ? props.requestOrderDetail.RequestOrderId : '-'}
                                            </span>
                                        </span>
                                        <span className={'aaa-cart-row-column'}>
                                            <span className={'aaa-cart-row-column-heading'}>Sales Order</span>
                                            <span className={'aaa-cart-row-column-text'}>{props.requestOrderDetail.SalesId}</span>
                                            <span className={'aaa-cart-row-column-heading'}>Invoice Number</span>
                                            <span className={'aaa-cart-row-column-text'}>
                                                {props.requestOrderDetail.InvoiceId ? props.requestOrderDetail.InvoiceId : '-'}
                                            </span>
                                            <span className={'aaa-cart-row-column-heading'}>Invoice Date</span>
                                            <span className={'aaa-cart-row-column-text'}>
                                                {props.requestOrderDetail.InvoiceDate
                                                    ? moment(props.requestOrderDetail.InvoiceDate).format('DD/MM/YYYY')
                                                    : '-'}
                                            </span>
                                        </span>
                                        <span className={'aaa-cart-row-column'}>
                                            <span className={'aaa-cart-row-column-heading'}>Order Date</span>
                                            <span className={'aaa-cart-row-column-text'}>
                                                {props.requestOrderDetail.OrderDate
                                                    ? moment(props.requestOrderDetail.OrderDate).format('DD/MM/YYYY')
                                                    : '-'}
                                            </span>
                                        </span>
                                    </div>
                                    <>
                                        <div
                                            className={'aaa-cart-row margin-0'}
                                            key={props.requestOrderDetail.DetailName}
                                            style={{ borderBottom: 0 }}
                                        >
                                            <span className={'aaa-cart-row-column'}>
                                                <span className={'aaa-cart-row-column-heading'}>{props.requestOrderDetail.DetailName}</span>
                                                <span className={'aaa-cart-row-column-text'}>{props.requestOrderDetail.Alloy1}</span>
                                            </span>
                                            <span className={'aaa-cart-row-column'}>
                                                <span className={'aaa-cart-row-column-heading'}>{'Engraving Font'}</span>
                                                <span className={'aaa-cart-row-column-text'}>
                                                    {props.requestOrderDetail.EngravingText && props.requestOrderDetail.EngravingFont
                                                        ? props.requestOrderDetail.EngravingFont
                                                        : '-'}
                                                </span>
                                            </span>
                                            <span className={'aaa-cart-row-column'}>
                                                <span className={'aaa-cart-row-column-heading'}>{'ETA'}</span>
                                                <span className={'aaa-cart-row-column-text'}>
                                                    {props.requestOrderDetail.RequestedReceivedDate
                                                        ? moment(props.requestOrderDetail.RequestedReceivedDate).format('DD/MM/YYYY')
                                                        : '-'}
                                                </span>
                                            </span>
                                        </div>
                                        <div
                                            className={'aaa-cart-row margin-0'}
                                            key={`Size ${props.requestOrderDetail.DetailName}`}
                                            style={{ borderBottom: 0 }}
                                        >
                                            <span className={'aaa-cart-row-column'}>
                                                <span className={'aaa-cart-row-column-heading'}>{'Size'}</span>
                                                <span className={'aaa-cart-row-column-text'}>
                                                    Size {props.requestOrderDetail.RingSizeLabel} ( &Oslash;{' '}
                                                    {props.requestOrderDetail.RingInsideDiameter})
                                                </span>
                                            </span>
                                            <span className={'aaa-cart-row-column'}>
                                                <span className={'aaa-cart-row-column-heading'}>{'Engraving Copy'}</span>
                                                <span className={'aaa-cart-row-column-text detail-history-text'}>
                                                    {props.requestOrderDetail.EngravingText ? props.requestOrderDetail.EngravingText : '-'}
                                                </span>
                                            </span>
                                            <span className={'aaa-cart-row-column'}>
                                                <span className={'aaa-cart-row-column-heading'}>{'Comments'}</span>
                                                <span className={'aaa-cart-row-column-text'}>
                                                    {props.requestOrderDetail.ItemNotes ? props.requestOrderDetail.ItemNotes : '-'}
                                                </span>
                                            </span>
                                        </div>
                                        <div className={'aaa-cart-row'} key={`Size ${props.requestOrderDetail.name}`}>
                                            <span className={'aaa-cart-row-column'}>
                                                <span className={'aaa-cart-row-column-heading'}>{'Specification'}</span>
                                                <span className={'aaa-cart-row-column-text detail-history-text'}>
                                                    {props.requestOrderDetail.DiamondCount
                                                        ? `${props.requestOrderDetail.DiamondCount} Diamonds, ${props.requestOrderDetail.RingWidth} Wide, ${props.requestOrderDetail.RingHeight} thick`
                                                        : `${props.requestOrderDetail.RingWidth} Wide, ${props.requestOrderDetail.RingHeight} thick`}
                                                </span>
                                            </span>
                                            <span className={'aaa-cart-row-column'}>
                                                <span className={'aaa-cart-row-column-heading'}>{'Reference Number'}</span>
                                                <span className={'aaa-cart-row-column-text'}>
                                                    {props.requestOrderDetail.ReferenceNumber
                                                        ? props.requestOrderDetail.ReferenceNumber
                                                        : '-'}
                                                </span>
                                            </span>
                                            <span className={'aaa-cart-row-column individual-price-content'}>
                                                <span className={'aaa-cart-row-column-heading'}>{''}</span>
                                                <span className={'aaa-cart-row-column-text individual-ring-price'}>
                                                    ${numberWithCommas(props.requestOrderDetail.B2CPrice)}
                                                </span>
                                            </span>
                                        </div>
                                    </>
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            ) : !props.isLoading ? (
                <div className={'row aaa-cart-wrapper'}>
                    <div className='col-auto col-sm-auto col-md-12 col-lg-12 ms-order-history__empty-message-container'>
                        <p className='ms-order-history__empty-message'>{'You currently do not have any order history detail to view.'}</p>
                    </div>
                </div>
            ) : (
                <div className={'row aaa-cart-wrapper'}>Loading...</div>
            )}
        </>
    );
};
